export enum DocumentType {
  WithoutDocument = 0,
  NIF = 1,
  NIE = 2,
  Passport = 3,
  RUT = 7,
}

export interface SelectOption<T> {
  label: string;
  value: T;
}

export const DocumentTypeOptions: SelectOption<DocumentType>[] = [
  {
    label: 'common.document_type_enum.WithoutDocument',
    value: DocumentType.WithoutDocument,
  },
  { label: 'common.document_type_enum.NIF', value: DocumentType.NIF },
  { label: 'common.document_type_enum.NIE', value: DocumentType.NIE },
  { label: 'common.document_type_enum.RUT', value: DocumentType.RUT },
  { label: 'common.document_type_enum.Passport', value: DocumentType.Passport },
];
